import { CheckCircledIcon, CircleIcon, ExclamationTriangleIcon } from '@radix-ui/react-icons';
import './Editor.css';

interface StatusBarProps {
  message: string | null;
  type: 'error' | 'warning' | 'success';
}

const icons = {
  error: <CircleIcon />,
  warning: <ExclamationTriangleIcon />,
  success: <CheckCircledIcon />,
}

export function StatusBar({ message, type }: StatusBarProps) {
  if (!message || message.trim() === '') return null;

  return (
    <div className="status-bar">
      {type && icons[type]}
      <span>{message}</span>
    </div>
  );
}
